import { PageContent, PageHeader } from '@/components';
import { MasterTableResourceGuard } from '@/features/authentication/_components/MasterTableResourceGuard';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CreateMasterTableButton } from '../../components';
import { ReservedProjectFormDrawer } from '../_components/ReservedProjectFormDrawer';
import { ReservedProjectTable } from '../_components/ReservedProjectTable';

const ReservedProjectsPage: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader
        title={t('reserved-project')}
        breadcrumbs={[
          {
            title: t('master-table-management'),
            href: '/master-table',
          },
          { title: t('reserved-project') },
        ]}
        buttons={
          <MasterTableResourceGuard onlyEdit>
            <CreateMasterTableButton type="reserved-project" />
          </MasterTableResourceGuard>
        }
      />
      <PageContent>
        <ReservedProjectTable />
        <ReservedProjectFormDrawer />
      </PageContent>
    </>
  );
};

export default ReservedProjectsPage;
